<template>
  <v-app-bar color="white lighten-4" height="40px" fixed>
    <v-toolbar-title class="pl-2">
      <a
        href="/"
        class="font-weight-medium purple--text text--darken-4"
        style="text-decoration: none; font-size: 16px;"
      >NowNow</a>
    </v-toolbar-title>

    <v-spacer></v-spacer>

    <template v-if="loggedIn==false">
      <v-btn
        color="transparent"
        elevation="0"
        class="px-0 mt-0 text-capitalize"
        rounded
        small
        style="outline: none;"
      >
        <a
          href="/login"
          class="caption purple--text text--darken-4"
          style="text-decoration: none;"
        >Log in</a>
      </v-btn>

      <v-btn
        color="purple darken-4"
        elevation="0"
        class="px-2 mt-0 mr-0"
        small
        style="outline: none;"
      >
        <a
          href="/signup"
          class="caption font-weight-light text-capitalize white--text"
          style="text-decoration: none;"
        >{{ $t('templates.Menu.signUp') }}</a>
      </v-btn>
    </template>

    <template v-else>
      <v-btn
        color="transparent"
        elevation="0"
        class="pr-2 mt-0 text-capitalize"
        rounded
        small
        style="outline: none;"
        @click="signOut"
      >
        <a
          class="caption purple--text text--darken-4"
          style="text-decoration: none; "
        >{{ $t('templates.Menu.logOut') }}</a>
      </v-btn>
    </template>
  </v-app-bar>
</template>

<script>
import { auth } from "@/config/firebaseConfig";
export default {
  data() {
    return {
      loggedIn: false,
    };
  },
  methods: {
    signOut() {
      auth.signOut().then(() => {
        window.location.href = `${process.env.VUE_APP_USER_URL}login`;
      });
    },
    setupFirebase() {
      auth.onAuthStateChanged((user) => {
        if (user) {
          this.loggedIn = user.emailVerified ? true : false;
        }
      });
    },
  },
  mounted() {
    this.setupFirebase();
  },
};
</script>
<style>
.v-toolbar__content,
.v-toolbar__extension {
  padding: 4px 8px !important;
}
</style>